import React, { useState } from 'react'
import CalendarDay from './CalendarDay'
import HintButton from '../../components/HintButton'
import ConfirmationPopup from '../../components/ConfirmationPopup'
import _ from 'lodash'
import moment from 'moment'
import '../../assets/css/pages/calendar/calendar.css'
import PropTypes from 'prop-types'
import { mod, getDayArray, defineQuestTypes } from '../../util'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ExpeditionsAssignmentModal from '../Expeditions/ExpeditionsAssignmentModal'

library.add(faChevronLeft, faChevronRight)

class Calendar extends React.Component {
  constructor(props) {
    super(props)
    const now = moment()
    this.state = {
      showDeleteConfirmation: {show:false, mode:''},
      day:    parseInt(now.format('D')),
      month:  parseInt(now.format('M')),
      year:   parseInt(now.format('YYYY'))
    }
  }

  handleDeletePriorAssignments = ()=> this.setState({  showDeleteConfirmation: {show: true, mode:'default'} })

  onConfirmationDeletion = ()=> {
    const { deletePriorAssignments, fetchCalendarData, filterCommittedCourseIds, filterCommittedSectionIds, filterCommittedStudentIds, filterCommittedContentTypes, meMode } = this.props
    deletePriorAssignments(fetchCalendarData, filterCommittedCourseIds, filterCommittedSectionIds, filterCommittedStudentIds, filterCommittedContentTypes)
  }

  onConfirmationCancel = () => {
    const { clearDeletePriorState } = this.props
    clearDeletePriorState()
    this.setState({ showDeleteConfirmation: {show: false, mode:''} })
  }

  changeMonth = (increment = true) =>{
    // The month is stored in the state 1-indexed, ie 1 = January, not 0 = January since it's easier to
    //    convert the month to a valid moment().
    // The modulus range for months is zero-indexed however (ie, [0, 11] is the range when you mod([1,12], 12)).
    //
    // We can convert from non-zero-indexed to zero-index just for the purposes of this formula.
    // If incrementing: monthVal = (month + 1) - 1 = month. The addition is for the incrementation, the minus is
    //    to convert to zero indexing.
    // If decrementing: monthVal = (month - 1) - 1 = month - 2. The first subtraction is for decrementation, and
    //    the second minus is to convert to zero indexing.
    // We then take the monthVal modulus 12 and convert it back to non-zero-indexed, hence the final plus one.
    const newMonth = mod((increment ? this.state.month : this.state.month-2), 12) + 1

    let newYear = this.state.year
    if(newMonth > this.state.month && !increment) {
      newYear--
    } else if(newMonth < this.state.month && increment) {
      newYear++
    }
    this.setState({ month: newMonth, year: newYear })
  }
  // used to generate a moment that represents the month and year that a user is currently looking at on the calendar.
  getMonthMoment = ()=> moment([this.state.month, 1 , this.state.year].join('/'))

  isDeactivated = () => _.isEmpty(this.props.selectedAssignments)



  render() {
    // variables and data
    const { isLoading, selectedAssignmentIsSandbox, uniqueAssignments, selectedDate, selectedAssignments, numberOverflowing, meMode, deletePriorLoading,deletePriorErrors, deletePriorCount, selectedTagRef } = this.props
    // functions
    const { setSelectedAssignment, deletePriorAssignments, handleMakeChangesOrDeleteClick, fetchCalendarData } = this.props
    //filter specifc functions
    const { filterCommittedCourseIds, filterCommittedSectionIds, filterCommittedStudentIds, filterCommittedContentTypes } = this.props
    const shortDayNames = ['Sun', 'Mon','Tue','Wed','Thu','Fri','Sat']
    return(
      <div className='tyto-calendar'>
        <div className='calendar-header'>
          <div className='controls-row'>
            <span onClick={()=>this.changeMonth(false)} className='chev-left'>
              <FontAwesomeIcon icon='chevron-left'/>
            </span>
            <span className='date-header'>{(this.getMonthMoment().format('MMMM')).concat(' ',this.getMonthMoment().format('YYYY'))} </span>
            <span onClick={()=>this.changeMonth(true)} className='chev-right'>
              <FontAwesomeIcon icon='chevron-right'/>
            </span>
          </div>
          {/*Map each of the short day names for the header.*/}
          <div className='day-name-row'>
            {_.map(shortDayNames, (day) =>
              <span key={day} className='day-name'>{day}</span>
            )}
          </div>
        </div>

        {/*Map through the array of Day objects and assignments and create a Calendar Day for the current month*/}
        {_.flatMap(getDayArray(this.getMonthMoment()), (row,rowIndex) =>
          <div key={rowIndex} className='week-row'>
            {_.map(row, (dayObj,colIndex) => {
              let dayAssignments = []
              let isSelectedDate = false
              _.map(uniqueAssignments, assignment =>{
                if(moment(assignment.assignedAt).isBetween(moment(dayObj.isoString),moment(dayObj.isoString).add(1,'d'),null, '[)')){
                dayAssignments.push(assignment)
              }})
              if (moment(dayObj.isoString).isSame(selectedDate, 'day') && !_.isEmpty(selectedDate)) {
                isSelectedDate = true
              }
              return(<CalendarDay
                day={dayObj}
                key={rowIndex+''+colIndex}
                assignments={dayAssignments}
                selectedAssignments={selectedAssignments}
                setSelectedAssignment={setSelectedAssignment}
                isSelectedDate={isSelectedDate}
                numberOverflowing={numberOverflowing}
                selectedTagRef={selectedTagRef}
              />)
            })}
          </div>
        )}

        <div className='calendar-footer'>
          <div className='footer-left'>
            <button className='deactivate-button' onClick={this.handleDeletePriorAssignments}>Delete Prior Assignments</button>
            <HintButton hint = "This button deletes all the assignments prior to today that have not been completed."/>
            <span className='hint-subtitle'>What does this button do?</span>
          </div>
          <div className='footer-right'>
            <button
              className={"delete-button " + (this.isDeactivated() ? "greyed-out": "")}
              onClick={() => {
                if(this.props.selectedAssignments.contentType === 'expedition'){
                  this.setState({showDeleteConfirmation: {show: true, mode:'expedition'}})
                }else{
                  !this.isDeactivated() && handleMakeChangesOrDeleteClick(this.props.selectedAssignments.assignments,true)
                }
                
              }}
              disabled = {this.isDeactivated()}
            >
              Delete Assignment
            </button>
            <button
              className={"changes-button " + (this.isDeactivated() ? "greyed-out" : "")}
              onClick={() => {!this.isDeactivated() && handleMakeChangesOrDeleteClick(this.props.selectedAssignments.assignments,false)}}
              disabled = {this.isDeactivated()}
            >Make Changes</button>
          </div>
        </div>

        {this.state.showDeleteConfirmation.show && this.state.showDeleteConfirmation.mode === 'default' && 
          <ConfirmationPopup
            title='Delete Prior Assignments'
            bodyHtml={<p className='message'>You are about to delete assignments prior to today for <b>{meMode ? "yourself" : "all students"}</b>. Are you sure you want to proceed?</p>}
            confirmationText='Yes, delete them'
            errorMessage={ !_.isEmpty(deletePriorErrors) ? "The assignments have been cleared from your calendar, however we may have experienced some issues with removing the assignments from the game. If you experience any issues with these assignments in-game, please contact support." : null}
            successMessage={_.isNumber(deletePriorCount) && deletePriorCount !== undefined ? deletePriorCount + " assignments prior to today successfully deleted!" : null}
            warningMessage = {deletePriorCount === undefined ? "There are no assignments on the calendar to be deleted!" : null }
            onConfirm={this.onConfirmationDeletion}
            onCancel={this.onConfirmationCancel}
            //set loadingAnimation for deleting process
            isLoading={deletePriorLoading}
            //hide the action buttons on either success or fail delete query
            hideButton = {_.isNumber(deletePriorCount)|| deletePriorCount === undefined || !_.isEmpty(deletePriorErrors) ? true : false}
          />
        }
        {this.state.showDeleteConfirmation.show && this.state.showDeleteConfirmation.mode === 'expedition' && <ExpeditionsAssignmentModal expedition={this.props.selectedAssignments.assignments[0]} isDelete={true} handleClose={this.onConfirmationCancel}/>}
      </div>
    )
  }
}

Calendar.propTypes = {
  //TODO: add proptypes or move this somwehere else
}
export default Calendar
